export default __webpack_public_path__ + "static/media/NorthAmerica_05.05747e3b.png";